import type { BadgeProps } from '@/components/ui/badge';

// Shared by Reconciliation → Cash and Reports → Reconciliation → Cash Records,
// so a row is labelled the same way on both pages.

export type SystemNote = 'Short' | 'Excess' | 'Tallied';

/** Counted minus expected, to the cent. Subtracting two money floats can leave
 *  a stray 1e-13, which would otherwise read as "Excess $0.00". */
export function cashNet(actual: number, system: number): number {
  return Math.round((actual - system) * 100) / 100;
}

export function systemNote(netValue: number): SystemNote {
  if (netValue < 0) return 'Short';
  if (netValue > 0) return 'Excess';
  return 'Tallied';
}

export const NOTE_VARIANT: Record<SystemNote, BadgeProps['variant']> = {
  Short: 'destructive',
  Excess: 'warning',
  Tallied: 'success',
};

/** A YYYY-MM-DD day string as MM/DD/YYYY. No timezone math: it is already the
 *  business-local day the server bucketed into. */
export function formatMDY(ymd: string): string {
  const [y, m, d] = ymd.split('-');
  return m && d && y ? `${m}/${d}/${y}` : ymd;
}
